export const ADD_RECORDS = 'ADD_RECORDS'
export const GET_RECORDS = 'GET_RECORDS'
export const COUNT_RECORDS= 'COUNT_RECORDS'
export const SET_STEP = 'SET_STEP'
export const SET_SESSION_ID = 'SET_SESSION_ID'
